export default class RecuperacionClave {
    constructor(
        public cedulaBeneficiario: string = null,
        public tipoEnvio: string = null,
        public valor: string = null,
		public captchaToken: string = ""
    ) {}
}